
import React, { Component } from 'react'; 
import { Link } from "react-router-dom";
class Frase extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Completa la Frase</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            <h2>
           
            </h2>
            </div>
        <iframe title='Frase' allowfullscreen width="1080" height="720" frameborder="1" src="https://es.educaplay.com/juego/15623021-la_inteligencia_artificial_en_la_educacion.html"></iframe>
          </div>
          <div className="containerjuego">
                <Link className="button" to="/juego">
                Regresar
              </Link>
            </div>
            </span>
            </div>
          </div>

          );
    } 
} 

export default Frase;